<template>
  <div>
    <p class="titleComponent">{{title}}</p>
    <div class="personalInfoTitle">
      <p>Nombre: <span class="personalInfoValue">{{ name | camelize }}</span></p>
      <p>R.F.C.: <span class="personalInfoValue">{{rfc}}</span></p>
    </div>
  </div>
</template>

<script>
import('@/assets/css/stylesheet.css')

export default {
  data() {
    return {
    }
  },
  name: 'PersonalInfoComponent',
  props: ["title", "name", "rfc"]
}
</script>